import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CommonModuleP8} from "@Common/common-p8.module";
import {MatAngularModule} from '@Common/mat-angular.module';
import { FlexModule } from "@Common/widgets/flex-layout/flex/flex.module";
import { DepositEditComponent } from './deposit-edit/deposit-edit.component';
import { BoxEditComponent } from './deposit-edit/box-edit/box-edit.component';
import { DocumentEditComponent } from './deposit-edit/document-edit/document-edit.component';
import { DialogIncompleteComponent } from './modal/incomplete/incomplete.component';
import {TreeExtendedModule} from "@Common/widgets/general/tree-extended/tree-extended.module";
import { TakeChargeComponent } from './take-charge/take-charge.component';
import {VersementComponent} from "app/archivage/deposit/consultation/versement";
import {BoiteComponent} from "app/archivage/deposit/consultation/boite/boite";
import {DocumentComponent} from "app/archivage/deposit/consultation/boite/document/document";
import {ReactiveFormsModule} from '@angular/forms';
import { DialogDoneComponent } from './modal/dialog-done/dialog-done.component';
import {CommonArchivageModule} from 'app/archivage/common/common.module';
import { DialogArchivedComponent } from './modal/dialog-archived/dialog-archived.component';
import { BoiteObservationComponent } from './consultation/boite/boite-observation/boite-observation.component';
import { EditDocComponent } from './consultation/boite/document/edit-doc/edit-doc.component';

@NgModule({
  declarations: [
    DepositEditComponent,
    BoxEditComponent,
    DocumentEditComponent,
    DialogIncompleteComponent,
    TakeChargeComponent,
    VersementComponent,
    BoiteComponent,
    DocumentComponent,
    DialogDoneComponent,
    DialogArchivedComponent,
    BoiteObservationComponent,
    EditDocComponent,
  ],
  exports: [
    TakeChargeComponent,
    DepositEditComponent,
  ],
  imports: [
    FlexModule,
    MatAngularModule,
    CommonModule,
    CommonModuleP8,
    TreeExtendedModule,
    ReactiveFormsModule,
    CommonArchivageModule,
  ]
})
export class DepositModule { }
